"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _constants = require("../../constants");
var _location = require("../../utils/location");
class NoAuthStrategy {
  constructor(redirectToIndex, config) {
    this.execAuthentication = () => {
      const pathname = (0, _location.removePrefix)(window.location.pathname, this.config.appPrefix);
      if (pathname === '/' || pathname === '') {
        this.redirectToIndex();
      }
    };
    this.redirectToLogin = () => {};
    this.completed = () => {
      const pathname = (0, _location.removePrefix)(window.location.pathname, this.config.appPrefix);
      if (pathname === '/' || pathname === '') {
        this.redirectToIndex();
        return true;
      }
      return true;
    };
    this.logout = () => {};
    this.name = _constants.AUTH_STRATEGY.NO_AUTH;
    this.config = config;
    this.redirectToIndex = redirectToIndex;
  }
}
var _default = exports.default = NoAuthStrategy;